import parsePhoneNumber, { AsYouType } from "libphonenumber-js";

export const formatPhoneNumber = (phone: string): string => {
    if (!phone) return phone;

    return parsePhoneNumber(phone)?.formatInternational() || phone;
};

export const isValidPhone = (value: string): boolean => {
    const ast = new AsYouType();
    ast.input(value);
    const phoneNumber = ast.getNumber();

    return !(!phoneNumber || phoneNumber.isNonGeographic());
};
